import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';

import { TituloReceberVisualizacaoComponent } from './titulo-receber-visualizacao.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TituloReceberVisualizacaoComponent
    ],
    exports: [
        TituloReceberVisualizacaoComponent
    ]
})
export class TituloReceberVisualizacaoModule { }
